<script setup lang="ts">
import EditDeptDrawer from '@/pages/erp/du/org/view/du-department-drawer.vue'
import type { DeptProperties } from '@/pages/erp/du/org/db/du-dept-types'
import AddEditOrg from './du-add-edit-org.vue'
import DsActionAuth from "@/pages/erp/ds/menu/view/ds-action-auth.vue";
import DuSubOrg from "@/pages/erp/du/org/view/du-sub-org.vue";

definePage({
  meta: {
    action: 'manage',
    subject: 'DUDEPARTMENT',
  },
})

// const compId = ref(useStorage('compNo', 'nstc').value)
// const orgType = ref()
const depNo = ref()
const depName = ref()
// const router = useRouter()

const triggerSearch = ref(new Date().getTime())

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}


const subDepts = ref({})

// 👉 Add new data
/*const fetchSubDepts = async (deptNo: string) => {
  await $api('/du/org/class/getSubDept', {
    method: 'GET',
    params: { upperDepNo: deptNo },
  }).then((resp) => {
    console.log('fetchSubDepts resp: ', resp)
    subDepts.value[deptNo] = resp
    console.log(subDepts.value[deptNo])
  })
}*/

// Headers

const grid1Headers = [
  { title: '#', key: 'id', width: '50px'  },
  { title: '', key: 'data-table-expand', width: '50px' },
  { title: '單位名稱', key: 'depName', width: '150px' },
  { title: '標籤', key: 'orgType', width: '100px' },
  { title: 'Email', key: 'email' },
  { title: '電話', key: 'phone' },
  { title: '狀態', key: 'status', width: '50px' },
  { title: '操作', key: 'actions', sortable: false, width: '200px'}
]

const searchResultHeaders = [
  { title: '#', key: 'id', width: '50px'  },
  { title: '單位名稱', key: 'depName', width: '150px' },
  { title: '標籤', key: 'orgType', width: '100px' },
  { title: 'Email', key: 'email' },
  { title: '電話', key: 'phone' },
  { title: '狀態', key: 'status', width: '50px' },
  { title: '操作', key: 'actions', sortable: false, width: '200px'}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: deptsData, execute: fetchDepts, isFetching: loading } = await useApi<any>(createUrl('/du/org/class/getRootDeptPage', {
  query: {
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const inSearch = ref(false)

watch(depNo, (val) => {
  console.log('watch depNo: ', val)
  searchDepts()
})

watch(depName, (val) => {
  console.log('watch depName: ', val)
  searchDepts()
})

const searchResult = ref([])
const searchResultTotal = ref(0)
const searchDepts = async () => {
  if ((typeof depNo.value != 'string' || depNo.value == '') && (typeof depName.value != 'string' || depName.value == '')) {
    inSearch.value = false
    fetchDepts()
    return
  }
  inSearch.value = true
  let query = {
    page: page.value,
    size: size.value
  }
  if (typeof depNo.value == 'string' && depNo.value.length > 0) {
    query['depNo'] = depNo.value
  }
  if (typeof depName.value == 'string' && depName.value.length > 0) {
    query['depName'] = depName.value
  }
  const resp = await $api('/du/org/department/searchDept', {
    method: 'GET',
    query,
  });
  searchResult.value = resp.data.deptPage.content;
  searchResultTotal.value = resp.data.deptPage.totalElements
}


const datas = computed((): DeptProperties[] => deptsData.value.content.map((it: { id: string; DEPNO: string; }) => {
  it.id = it.DEPNO
  return it
}))
const totalDatas = computed(() => deptsData.value.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isEditDataVisible = ref(false)
const isNewData = ref(true)

let voData: DeptProperties;

const createData = () => {
  isEditDataVisible.value = true
  voData = {
    depNo: ''
  }
  // isEditDataDrawerVisible.value = true
  isNewData.value = true
}
const isAdmin = ref(true)
const userRoles = ref(useStorage('roles', []).value)
const userDepNo = ref(useStorage('depNo', '').value)
if (userRoles.value.length > 0 && userRoles.value.includes('AS-Manager')) {
  isAdmin.value = false
}

const deptData = async (userDepNo: string ) => {
  try {
    const resp = await $api('/du/org/department/loadDept', {
      method: 'GET',
      query: {
        orgType: 'A',
        depNo: userDepNo,
      },
    });
    return resp.data.dept;
  } catch (error) {
    console.error("Error fetching user:", error);
    return null;
  }
}

const editData = (deptData: DeptProperties) => {
  console.log(deptData)
  voData = deptData
  console.log('editDept: ', voData)
  // isEditDataDrawerVisible.value = true
  isNewData.value = false
  isEditDataVisible.value = true
}

// 👉 新增部門資料
const addNewData = async (deptData: DeptProperties) => {
  console.log(deptData)
  await $api('/du/org/department/createDept', {
    method: 'POST',
    body: { dept: deptData },
  }).then(() => {
    $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDepts()
}

const updateData = async (deptData: DeptProperties) => {
  console.log('updateData',deptData)
  await $api('/du/org/department/updateDept', {
    method: 'PUT',
    body: { dept: deptData },
  }).then(() => {
    $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDepts()
}


// 👉 Delete data
const deleteData = async (deptData: DeptProperties) => {

  $swal({
    title: `確定要作廢 ${deptData.depName} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      deptData.status = 'CA'
      $api(`/du/org/department/updateDept`, {
        method: 'PUT',
        body: { dept: deptData },
      }).then(() => {
        $swal({
          position: 'top-end',
          title: "作廢成功",
          timer: 1500,
          icon: "success"
        });
        triggerSearch.value = new Date().getTime()
        // refetch Data
        fetchDepts()
      })
    }
  });

}

// 👉 Enable data
const enableData = async (deptData: DeptProperties) => {

  $swal({
    title: `確定要啟用 ${deptData.depName} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      deptData.status = 'OP'
      $api(`/du/org/department/updateDept`, {
        method: 'PUT',
        body: { dept: deptData },
      }).then(() => {
        $swal({
          position: 'top-end',
          title: "啟用成功",
          timer: 1500,
          icon: "success"
        });
        triggerSearch.value = new Date().getTime()
        // refetch Data
        fetchDepts()
      })
    }
  });

}

// const clickRow = (event: any, select: { item: DeptProperties; }) => {
//   console.log('clickRow: ', event, select)
//   editData(select.item)
// }

watch(isEditDataVisible,
  ()=>{
    fetchDepts()
  }
)

const orgText = (orgType: string) => {
  switch (orgType) {
    case 'A':
      return '協會'
    case 'C':
      return '中心'
    case 'T':
      return '隊伍'
    case 'X':
      return '外部'      
    default:
      return orgType
  }
}

const statusText = (status: string) => {
  switch (status) {
    case 'CA':
      return '作廢'
    case 'OP':
      return '正常'
    default:
      return '正常'
  }
}

onMounted(() => {
  if (userRoles.value.length > 0 && userRoles.value.includes('AS-Manager')) {
    deptData(userDepNo.value).then((resp) => {
      voData = resp
      isNewData.value = false
      isEditDataVisible.value = true
    })
  }
})

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6" v-if="!isEditDataVisible">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
          cols="12"
          sm="3"
        >
          <AppTextField
            v-model="depNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入單位代號"
          />
        </VCol>
        <VCol
          cols="12"
          sm="3"
        >
          <AppTextField
            v-model="depName"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入單位名稱"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
          prepend-icon="tabler-plus"
          @click="createData"
        >
          新增單位
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
      v-if="isAdmin && !inSearch"
      v-model:items-per-page="size"
      v-model:page="currentPage"
      :item-value="row => `${row.depNo ?? ''}@${row.postNo ?? ''}`"
      :items="datas"
      :items-length="totalDatas"
      :headers="grid1Headers"
      :loading="loading"
      class="text-no-wrap"
      expand-on-click
      @update:options="updateOptions"
      show-expand
    >
      <template #expanded-row="slotProps">
        <tr>
          <td  colspan="8">
            <du-sub-org :upper-dep-no="slotProps.item.depNo" @edit-data="editData" @delete-data="deleteData" @enable-data="enableData" :trigger-search="triggerSearch" />
          </td>
        </tr>
<!--        <tr v-for="it in subDepts[slotProps.item.depNo]">-->
<!--          <td></td>-->
<!--          <td></td>-->
<!--          <td>-->
<!--            <div class="text-body-1 text-high-emphasis">-->
<!--              {{ it.depName }}-->
<!--            </div>-->
<!--          </td>-->
<!--          <td>-->
<!--            <VChip class="rounded-pill" :color="it.orgType == 'A' ? 'warning' : it.orgType == 'T' ? 'success' : 'info'" variant="flat">-->
<!--              {{ orgText(it.orgType) }}-->
<!--            </VChip>-->
<!--          </td>-->
<!--          <td>-->
<!--            <div class="text-body-1 text-high-emphasis">-->
<!--              {{ it.email }}-->
<!--            </div>-->
<!--          </td>-->
<!--          <td>-->
<!--            <div class="text-body-1 text-high-emphasis">-->
<!--              {{ it.phone }}-->
<!--            </div>-->
<!--          </td>-->
<!--          <td>-->
<!--            <VChip class="rounded-pill" :color="it.status == 'CA' ? 'error' : 'success'" variant="flat">-->
<!--              {{ statusText(it.status) }}-->
<!--            </VChip>-->
<!--          </td>-->
<!--          <td>-->
<!--            <VBtn-->
<!--              variant="outlined"-->
<!--              density="compact"-->
<!--              style="margin-right: 10px;"-->
<!--              @click="editData(it)"-->
<!--            >-->
<!--              編輯-->
<!--            </VBtn>-->
<!--            <VBtn-->
<!--              variant="outlined"-->
<!--              density="compact"-->
<!--              style="margin-right: 10px;"-->
<!--              @click="deleteData(it)"-->
<!--            >-->
<!--              作廢-->
<!--            </VBtn>-->
<!--          </td>-->
<!--        </tr>-->
      </template>

      <template #item.id="{ item, index }">
        <div class="text-body-1 text-high-emphasis">
          {{ index + 1 }}
        </div>
      </template>
      <template #item.orgType="{ item }">
        <VChip class="rounded-pill" :color="item.orgType == 'A' ? 'warning' : item.orgType == 'T' ? 'success' : 'info'" variant="flat">
          {{ orgText(item.orgType) }}
        </VChip>
      </template>
      <template #item.status="{ item }">
        <VChip class="rounded-pill" :color="item.status == 'CA' ? 'error' : 'success'" variant="flat">
          {{ statusText(item.status) }}
        </VChip>
      </template>
      <!-- Actions -->
      <template #item.actions="{ item }">
        <VBtn
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="editData(item)"
        >
          編輯
        </VBtn>
        <VBtn v-if="item.status=='CA'"
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="enableData(item)"
        >
          啟用
        </VBtn>
        <VBtn v-else
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="deleteData(item)"
        >
          作廢
        </VBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
          v-model:page="currentPage"
          v-model:size="size"
          :items-per-page="size"
          :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- Search result table -->
    <VDataTableServer
      v-else
      v-model:items-per-page="size"
      v-model:page="currentPage"
      :item-value="row => `${row.depNo ?? ''}@${row.postNo ?? ''}`"
      :items="searchResult"
      :items-length="searchResultTotal"
      :headers="searchResultHeaders"
      :loading="loading"
      class="text-no-wrap"
      expand-on-click
      @update:options="updateOptions"
      show-expand
    >

      <template #item.id="{ item, index }">
        <div class="text-body-1 text-high-emphasis">
          {{ index + 1 }}
        </div>
      </template>
      <template #item.orgType="{ item }">
        <VChip class="rounded-pill" :color="toCode(item.orgType) == 'A' ? 'warning' : toCode(item.orgType) == 'T' ? 'success' : 'info'" variant="flat">
          {{ toText(item.orgType) }}
        </VChip>
      </template>
      <template #item.status="{ item }">
        <VChip class="rounded-pill" :color="item.status == 'CA' ? 'error' : 'success'" variant="flat">
          {{ statusText(item.status) }}
        </VChip>
      </template>
      <!-- Actions -->
      <template #item.actions="{ item }">
        <VBtn
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="editData(item)"
        >
          編輯
        </VBtn>
        <VBtn
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="deleteData(item)"
        >
          作廢
        </VBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
          v-model:page="currentPage"
          v-model:size="size"
          :items-per-page="size"
          :total-items="searchResultTotal"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditDeptDrawer
    v-model:isDrawerOpen="isEditDataDrawerVisible"
    :dept-data="voData"
    :is-new="isNewData"
    @create-data="addNewData"
    @update-data="updateData"
  />
  <AddEditOrg
    v-if="isEditDataVisible"
    v-model:isDrawerOpen="isEditDataVisible"
    :props-data="voData"
    :is-new="isNewData"
  />
</template>
